module.exports = __webpack_public_path__ + "static/weaving-71caec913fb9c36bee9e9c294f9d2eeb.webp";